import React from 'react'
import AvailableProduct from '../../Components/AvailableProduct'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'

function AvailableProductPage() {
  return (

    <>

    <div class="wrapper">
        <div class="inner_page_Sec">
        <div class="col-sm-8 float-left left_sec_table searchPageTop">
    
        <h1>Available Products</h1>

        <div className="table_data">
          <table border="0" cellspacing="0" cellpadding="0">
  <thead>
    <tr>
      <th>Sl No.</th>
      <th>Product</th>
      <th>Supplier/s</th>
      <th>Available in Qty.</th>
      <th>Usages (ব্যবহার)</th>
      <th>Picture of Bag</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>NEEM COATED UREA</td>
      <td>IFFCO, IPL, KRIBHCO, HURL, MATX, NFL, CIL, CFCL</td>
      <td>45 Kg Bag</td>
      <td>নাইট্রোজেন সরবরাহের মাধ্যমে, ইউরিয়া ক্লোরোফিল উৎপাদন বৃদ্ধি করে, সালোকসংশ্লেষণ বৃদ্ধি করে এবং উদ্ভিদ বৃদ্ধি ত্বরান্বিত করে, বিশেষ করে ফুল ও ফলের পর্যায়ে।</td>
      <td></td>
    </tr>
    <tr>
      <td>2</td>
      <td>DAP (Diammonium Phosphate) - NPK 17:44:0</td>
      <td>IFFCO, IPL, CIL, MOSAIC</td>
      <td>50 Kg Bag</td>
      <td>ফসফরাস মূলের বিকাশে গুরুত্বপূর্ণ ভূমিকা পালন করে, যা পুষ্টি এবং জল শোষণের জন্য অপরিহার্য। এটি ফুল, ফল এবং বীজ বিকাশেও সহায়তা করে। ডিএপিতে নাইট্রোজেনও থাকে, যা উদ্ভিদের বৃদ্ধির জন্য আরেকটি অপরিহার্য পুষ্টি উপাদান।</td>
      <td></td>
    </tr>
    <tr>
      <td>3</td>
      <td>NPK 10:26:26</td>
      <td>IFFCO, CIL, CFCL, KRIBHCO, NFL</td>
      <td>50 Kg Bag</td>
      <td>NPK 10:26:26 সার উদ্ভিদকে নাইট্রোজেন (N), ফসফরাস (P) এবং পটাসিয়াম (K) এর সুষম মিশ্রণ প্রদান করে। এটি শিকড়ের বৃদ্ধি, ফুল ও ফলের উন্নতি এবং সামগ্রিক উদ্ভিদের প্রাণশক্তি বৃদ্ধির জন্য বিশেষভাবে উপকারী। এই নির্দিষ্ট অনুপাতটি লিচিং প্রবণ মাটিতেও কার্যকর, যা ফসফরাস এবং পটাসিয়াম ধরে রাখতে সাহায্য করে।</td>
      <td></td>
    </tr>
    <tr>
      <td>4</td>
      <td>Other NPKs (16:16:16 / 14:35:14 / 12:32:16 / 28:28:0 / 20:20:0:13)</td>
      <td>—</td>
      <td>—</td>
      <td>এই সব সার গুলিতে নাইট্রোজেন (N), ফসফরাস (P) এবং পটাসিয়াম (K) এর সবকটা বা নির্দিষ্ট কয়েকটি ভিন্ন ভিন্ন অনুপাতের সুষম মিশ্রণ প্রদান করে। অনেকটা NPK 10:26:26 এর মতো।</td>
      <td></td>
    </tr>
    <tr>
      <td>5</td>
      <td>SSP (Single Super Phosphate)</td>
      <td>—</td>
      <td>—</td>
      <td>ফসফরাস মূলের বিকাশে গুরুত্বপূর্ণ ভূমিকা পালন করে, যা পুষ্টি এবং জল শোষণের জন্য অপরিহার্য। এটি ফুল, ফল এবং বীজ বিকাশেও সহায়তা করে।</td>
      <td></td>
    </tr>
    <tr>
      <td>6</td>
      <td>MOP (Muriate of Potash)</td>
      <td>—</td>
      <td>—</td>
      <td>এটিকে বাণিজ্যিক চাষীদের কাছে একটি জনপ্রিয় পছন্দ করে তোলে। ব্যাপক পুষ্টি সরবরাহের জন্য এমওপি একা ব্যবহার করা যেতে পারে অথবা সিঙ্গেল সুপারফসফেটের মতো অন্যান্য সারের সাথে মিশ্রিত করা যেতে পারে। উদ্ভিদের বৃদ্ধি এবং গুণমান, বর্ধিত ফলন ইত্যাদি।</td>
      <td></td>
    </tr>
  </tbody>
</table>
</div>

<h2>Various Essential and Non-Essential Plant Nutrients</h2>

<div className="table_data">
  <table border="0" cellpadding="0" cellspacing="0">
  <thead>
    <tr>
      <th>Sl. No.</th>
      <th>Name of the Nutrient</th>
      <th>Type</th>
      <th>Efficacy</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>1</td>
      <td>Nitrogen (N)</td>
      <td>Macronutrient</td>
      <td>Essential for building proteins, nucleic acids, and chlorophyll, vital for plant growth, metabolism, and health.</td>
    </tr>
    <tr>
      <td>2</td>
      <td>Phosphorus (P)</td>
      <td>Macronutrient</td>
      <td>Crucial for energy transfer within the plant, supporting root development, flowering, and fruit production.</td>
    </tr>
    <tr>
      <td>3</td>
      <td>Potassium (K)</td>
      <td>Macronutrient</td>
      <td>Regulates water uptake, improves drought and disease resistance, and enhances fruit quality.</td>
    </tr>
    <tr>
      <td>4</td>
      <td>Calcium (Ca)</td>
      <td>Macronutrient</td>
      <td>Important for cell wall and membrane integrity, root and shoot growth, and signaling pathways.</td>
    </tr>
    <tr>
      <td>5</td>
      <td>Magnesium (Mg)</td>
      <td>Macronutrient</td>
      <td>A key component of chlorophyll, vital for photosynthesis, and involved in enzyme activation.</td>
    </tr>
    <tr>
      <td>6</td>
      <td>Sulfur (S)</td>
      <td>Macronutrient</td>
      <td>Involved in amino acid and protein synthesis, essential oil and vitamin formation, and enzyme function.</td>
    </tr>
    <tr>
      <td>7</td>
      <td>Iron (Fe)</td>
      <td>Micronutrient</td>
      <td>Essential for chlorophyll formation and energy release from sugars.</td>
    </tr>
    <tr>
      <td>8</td>
      <td>Manganese (Mn)</td>
      <td>Micronutrient</td>
      <td>Serves as an activator for enzymes in growth processes and assists iron in chlorophyll formation.</td>
    </tr>
    <tr>
      <td>9</td>
      <td>Zinc (Zn)</td>
      <td>Micronutrient</td>
      <td>Involved in the synthesis of various proteins and hormones.</td>
    </tr>
    <tr>
      <td>10</td>
      <td>Copper (Cu)</td>
      <td>Micronutrient</td>
      <td>Promotes the formation of vitamin A, and assists in the utilization of other nutrients.</td>
    </tr>
    <tr>
      <td>11</td>
      <td>Boron (B)</td>
      <td>Micronutrient</td>
      <td>Necessary for cell wall formation, membrane integrity, and calcium uptake, affecting flowering, fruiting, and water transport.</td>
    </tr>
    <tr>
      <td>12</td>
      <td>Molybdenum (Mo)</td>
      <td>Micronutrient</td>
      <td>Required for nitrogen utilization and transformation into amino acids.</td>
    </tr>
    <tr>
      <td>13</td>
      <td>Chlorine (Cl)</td>
      <td>Micronutrient</td>
      <td>Involved in water splitting during photosynthesis.</td>
    </tr>
  </tbody>
</table>

</div>
    
        {/* <AvailableProduct/> */}


    
    
    
        </div>
        <div class="col-sm-4 float-left">
        <RightSidebarGlobal/>
        </div>
    
        </div>
        </div>
    
          {/* <DefaultPage pageTitle={pageContentData.pageTitle} pageContent = {pageContentData.pageContent} /> */}
        </>
   
  )
}

export default AvailableProductPage